const makePayload = (data, toCart = false, previewImageURL = "") => {
  const {
    dimensions,
    edges,
    sinks: selectedSinks,
    holes: selectedHoles,
    accessories: selectedAccessories,
  } = data;

  const {
    selectedTile,
    selectedVariation,
    texture,
    thickness,
    top,
    left,
    bottom,
    right,
  } = dimensions;

  /** Dimensions */
  const _top = Math.round(top);
  const _left = Math.round(left);
  const _right = Math.round(right);
  const _bottom = Math.round(bottom);

  const kantprofilers =
    selectedTile.name === "rak"
      ? {
          top: _top,
          bottom: _top,
          left: _left,
          right: _left,
        }
      : {
          top: _top,
          left: _left,
          bottom: _bottom,
          right: _right,
        };

  /** Tile */
  const selectedProduct = {
    ptype: texture.ptype,
    id: texture.id,
    kantprofilers: kantprofilers,
    params: {
      selectedType: selectedTile.name,
      thickness_selected_index: thickness,
      variant_selected: selectedVariation.id,
      variant_type: selectedVariation.type
    },
  };
  /** Edges */
  const tileEdges = Object.entries(edges).map(([key, edge]) => {
    return {
      ptype: edge.ptype,
      id: edge.id,
      type: key,
    };
  });

  /** Sinks */
  const sinks = selectedSinks.map((sink) => {
    const attachedHoles = Object.entries(sink.variant).reduce(
      (acc, iterator) => {
        const [key, value] = iterator;
        return {
          ...acc,
          [key]: value.value,
        };
      },
      {}
    );
    return {
      ptype: sink.ptype,
      id: sink.id,
      montering: sink.mounting.label,
      ...attachedHoles,
    };
  });

  /** Holes */
  const holes = selectedHoles.map((hole) => {
    const { enable_width_height, width, height } = hole;
    const enabledWidthHeight = enable_width_height
      ? {
          enable_width_height: {
            width,
            height,
          },
        }
      : {};

    return {
      ptype: hole.ptype,
      id: hole.id,
      ...enabledWidthHeight,
    };
  });

  /** Accessories */
  const accessories = selectedAccessories.map((accessory) => {
    return {
      ptype: accessory.ptype,
      id: accessory.id,
    };
  });

  const isAddToCart = toCart
    ? {
        add_to_cart: true,
        image: previewImageURL,
      }
    : {};

  const payload = {
    config: {
      product: selectedProduct,
      kantprofiler: tileEdges,
      disklador: sinks,
      hal_urtag: holes,
      tillbehor: accessories,
      ...isAddToCart,
    },
  };
  return payload;
};
export default makePayload;
